import menuModalRoutes from 'bento-ordering/menus/routes/modal';
import cartModalRoutes from 'bento-ordering/cart/routes/modal';

const modalRoutes = [...cartModalRoutes, ...menuModalRoutes];

export default modalRoutes;
